import {
  IWidgetConfigurationProps,
  withWidgetConfiguration,
} from "@sgwt-widget/core";

import { h } from "preact";
import { ApiBackedScComponent } from "../../common/components/ApiBackedScComponent";
import { ColumnChart } from "../../common/components/ColumnChart";
import { MakeGenericApiCall } from "../../common/generic/generic-api";
import {
  CheckReponseDataForError,
  GenericFilterBuilder,
} from "../../common/generic/generic-helper";
import { SCAttributes } from "../../common/generic/generic-sc-attributes";
import { SCKpis } from "../../common/generic/generic-sc-domain";
import { IGenericRequest } from "../../common/generic/generic-types";
import { ConvertFilter } from "../../common/salescredit/salescredit-filter-help";
import {
  BuildSalesCreditFilters,
  CreateDateFromFilter,
} from "../../common/salescredit/salescredit-search-criteria";
import { IProps } from "../../common/salescredit/salescredit-types";
import { Helper } from "../utils/helper";
import { getCommonPptExport } from "../../common/export/chart-helper";
import { find } from "lodash";
import { maxSelectedClients } from "../../common/utils/clientlistHelper";

export interface IState {
  data?: Highcharts.Options;
}

export class SalesCreditByRevenueCategoryClass extends ApiBackedScComponent<
  IProps & IWidgetConfigurationProps,
  IState
> {
  public constructor() {
    super();
    this.setState({
      data: {},
    });
  }

  public getPptExport() {
    return getCommonPptExport("bar", this.state.data, undefined, false);
  }

  protected renderWithDataReady(): JSX.Element {
    return <ColumnChart options={this.state.data} />;
  }

  protected async fetchApiData(props: IProps) {
    this.initCorrelationId();
    this.setDataStatus("loading");

    const attributes: string[] = [SCAttributes.SC_SUB_GRP_ID];
    const kpis: string[] = [SCKpis.SC_YTD];
    const filtersConverted = ConvertFilter(props.filters);
    const filters = BuildSalesCreditFilters(filtersConverted);
    const date = CreateDateFromFilter(filtersConverted);

    const genericRequest: IGenericRequest = {
      aggregationAttributes: attributes.join(","),
      date,
      filter: GenericFilterBuilder(filters),
      kpis: kpis.join(","),
    };
    const filterClientsSelected = find(filters, {
      attribute: "clientgen_id",
    });
    const clientsCount = filterClientsSelected
      ? filterClientsSelected.value.split("+").length
      : 0;
    if (filterClientsSelected && clientsCount >= maxSelectedClients) {
      this.setState({
        data: undefined,
      });
      this.setDataStatus("too-many-clients");
    } else {
      const result = await MakeGenericApiCall(
        props.headers,
        "sc",
        genericRequest,
        this.props.widgetConfiguration,
        this.state.correlationId
      );
      const errorStatus = CheckReponseDataForError(result);
      if (errorStatus) {
        this.setDataStatus(errorStatus);
        this.setStatusText(result.statusText);
        this.setState({
          data: undefined,
        });
        return;
      }

      const mappedData = Helper.MapData(result);
      const chartOptions = Helper.BuildChartOptions(mappedData);

      this.setState({
        data: chartOptions,
      });

      this.setDataStatus("ready");
    }
  }
}

export const SalesCreditByRevenueCategory = withWidgetConfiguration(
  SalesCreditByRevenueCategoryClass
);
